/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePaymentRequest } from '../models/CreatePaymentRequest';
import type { Payment, PaymentTransaction } from '../models/PaymentTransaction';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentService {
    /**
     * Create a new payment for a shipment
     * @param requestBody
     * @returns any Payment created successfully
     * @throws ApiError
     */
    public static postPaymentCreate(
        requestBody: CreatePaymentRequest,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: {
            paymentId?: string;
            paymentUrl?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - missing required fields`,
                401: `Unauthorized - user not authenticated`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Retrieve payment status by transaction ID
     * @param transactionId The Genie transaction ID
     * @returns any Payment status retrieved successfully
     * @throws ApiError
     */
    public static getPaymentStatus(
        transactionId: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: {
            transactionId?: string;
            state?: string;
            amount?: string;
            currency?: string;
            paymentDetails?: Record<string, any>;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payment/status/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad request - transaction ID is missing`,
                404: `Not found - transaction not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Webhook to receive transaction updates from Genie
     * @param requestBody
     * @returns any Webhook processed successfully
     * @throws ApiError
     */
    public static postPaymentWebhook(
        requestBody?: any,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment/webhook',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Request a refund for a completed transaction
     * @param requestBody
     * @returns any Refund requested successfully
     * @throws ApiError
     */
    public static postPaymentRefund(
        requestBody: {
            transactionId: string;
            /**
             * Refund amount (full amount if not specified)
             */
            amount?: number;
            reason?: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payment/refund',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - missing transaction ID or invalid state`,
                401: `Unauthorized - user not authenticated`,
                404: `Not found - transaction not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Admin - List all transactions with filters
     * @param userId Filter by user ID
     * @param shipmentId Filter by shipment ID
     * @param status Filter by payment status
     * @param fromDate Filter by start date
     * @param toDate Filter by end date
     * @returns any Transactions retrieved successfully
     * @throws ApiError
     */
    public static getPaymentAdminList(
        userId?: string,
        shipmentId?: string,
        status?: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Array<PaymentTransaction>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payment/admin/list',
            query: {
                'userId': userId,
                'shipmentId': shipmentId,
                'status': status,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized - user not authenticated`,
                403: `Forbidden - not an admin user`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get current user's payment history
     * @param shipmentId Filter by shipment ID
     * @returns any Payment history retrieved successfully
     * @throws ApiError
     */
    public static getPaymentMyHistory(
        shipmentId?: string,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Array<Payment>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payment/history',
            query: {
                'shipmentId': shipmentId,
            },
            errors: {
                401: `Unauthorized - user not authenticated`,
                500: `Internal server error`,
            },
        });
    }
}
